import { render, staticRenderFns } from "./DistributionsDetail.vue?vue&type=template&id=05c30e4b&scoped=true&"
import script from "./DistributionsDetail.vue?vue&type=script&lang=js&"
export * from "./DistributionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DistributionsDetail.vue?vue&type=style&index=0&id=05c30e4b&lang=scss&scoped=true&"
import style1 from "./DistributionsDetail.vue?vue&type=style&index=1&id=05c30e4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c30e4b",
  null
  
)

export default component.exports